// src/pages/TransNationsHome.jsx
import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import TransNationsAbout from "./TransNationsAbout";

const TransNationsHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("About TransNation");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const groupNames = [
    { label: "About TransNation", emoji: "🌍" }, 
    { label: "Global Expansion Engine", emoji: "🧭" },
    { label: "Cross-Border Trade", emoji: "📦" },
    { label: "Compliance & Trust", emoji: "🧾" },
    { label: "Global Workforce & Talent", emoji: "👨‍💻" },
    { label: "Funding & Financial Access", emoji: "💰" },
    { label: "Knowledge & Learning", emoji: "🧠" },
    { label: "Global Network & Collaboration", emoji: "🔗" },
    { label: "Global Dashboard", emoji: "📊" },
    { label: "Government & Institutional", emoji: "🏛️" },
    { label: "Integration Layer", emoji: "🧩" },
    { label: "TransNation X", emoji: "🚀" },
    { label: "MSME Owner's Productivity", emoji: "📈" }, 
    { label: "Interntional Business Startups", emoji: "📈" }, 
    { label: "TransNations Research Desk", emoji: "🧠" },  
    { label: "SigmaStudio", emoji: "🧮" },
    { label: "Processifyd", emoji: "🧱" },   
    { label: "International Business Games", emoji: "🎮" },
    { label: "Student's Digital Income", emoji: "👛" },  
      
  ];

  const menuButtons = [
    // 🧭 Global Expansion Engine & Awards
    { label: "My Income Credit", emoji: "🌱", link: "/myincomecredits", group: "Global Expansion Engine" },
    { label: "My Income", emoji: "💰", link: "/myincome", group: "Global Expansion Engine" },
    { label: "Income Estimation", emoji: "🔗", link: "/orderflow-earning-estimator", group: "Global Expansion Engine" },
    { label: "Kharcho Jeeto", emoji: "🗓️", link: "/kharchojeeto", group: "Global Expansion Engine" },
    { label: "Photo Can Win", emoji: "🏁", link: "/photocanwin", group: "Global Expansion Engine" },
    { label: "Become Reseller", emoji: "♻️", link: "/msme-enroll", group: "Global Expansion Engine" },
    { label: "Rewarding Ads", emoji: "🎁📢", link: "/visigift-home", group: "Global Expansion Engine" },
    { label: "Watch Rewarding Videos", emoji: "🎥", link: "/orderflow-spotbuy", group: "Global Expansion Engine" },
    { label: "Create Digital Boutique", emoji: "🛍️", link: "/digiboutique", group: "Global Expansion Engine" },

    // 🔄 MSME CCM (Contacts. Communication. Meetings)
    { label: "My Digital Card", emoji: "💼", link: "/msme-digitalcard", group: "Cross-Border Trade" },
    { label: "Client's Digital Card", emoji: "👤", link: "/contact-genious-clientcards", group: "Cross-Border Trade" },
    { label: "My Speaking Card", emoji: "🎙️", link: "/contact-genious-speakingcard", group: "Cross-Border Trade" },
    { label: "Card Visibility Dashboard", emoji: "📊", link: "/contact-genious-cardviewstats", group: "Cross-Border Trade" },
    { label: "Connect / PehchaanSetu", emoji: "🤝", link: "/pehchaansetu", group: "Cross-Border Trade" },
    { label: "Meeting Calendar", emoji: "📅", link: "/calendar-list", group: "Cross-Border Trade" },
    { label: "Visits for Meeting", emoji: "📍", link: "/visits-list", group: "Cross-Border Trade" },
    { label: "Meeting Thoughts", emoji: "💭", link: "/thoughts-list", group: "Cross-Border Trade" },
    { label: "Meeting TODO", emoji: "✅", link: "/todo-list", group: "Cross-Border Trade" },
    { label: "Meeting Tasks", emoji: "🛠️", link: "/tasks-list", group: "Cross-Border Trade" },
    { label: "Travelling for Meetings", emoji: "🚗", link: "/travels-list", group: "Cross-Border Trade" },
    { label: "Meeting Checklist", emoji: "📋", link: "/checklist-list", group: "Cross-Border Trade" },
    { label: "Meeting Record", emoji: "🗂️", link: "/meetings-list", group: "Cross-Border Trade" },
    { label: "Whisper", emoji: "🤫", link: "", group: "Cross-Border Trade" },
    { label: "Meeting Analytics AI", emoji: "🧠📈", link: "", group: "Cross-Border Trade" },
    { label: "Overview", emoji: "🧭", link: "/eximlens/overview", group: "Cross-Border Trade" },
    { label: "Data Behind the Lens", emoji: "📚", link: "/eximlens/data", group: "Cross-Border Trade" },
    { label: "Market Signals", emoji: "📊", link: "/eximlens/signals", group: "Cross-Border Trade" },
    { label: "Trade Focus Areas", emoji: "🌐", link: "/eximlens/focus", group: "Cross-Border Trade" },
    { label: "Think5Whys Insights", emoji: "🧠", link: "/eximlens/think5whys", group: "Cross-Border Trade" },
    { label: "MSME Action View", emoji: "🎯", link: "/eximlens/action", group: "Cross-Border Trade" },
    { label: "About & Disclaimer", emoji: "ℹ️", link: "/eximlens/about", group: "Cross-Border Trade" },
    
    // 🪞 Compliance & Trust
    { label: "Personal Digital Card", emoji: "📘", link: "/msme-digitalcard", group: "Compliance & Trust" },
    { label: "Owner's Self Management", emoji: "🙋‍♀️", link: "/msme-self-chronicles", group: "Compliance & Trust" },
    { label: "Personal Diary", emoji: "📔", link: "/mydiary-home", group: "Compliance & Trust" },
    { label: "DeepThinking", emoji: "🧩", link: "/fivewhys-analysis-home", group: "Compliance & Trust" },
    { label: "Focus Timer", emoji: "⏱️", link: "/msme-focustimerstart", group: "Compliance & Trust" },
    { label: "IKIGAI", emoji: "🌸", link: "/myprofile-ikigai", group: "Compliance & Trust" },
    { label: "My Outreach", emoji: "📣👥", link: "/outreach", group: "Compliance & Trust" },
    { label: "My Limit", emoji: "️📏", link: "/mylimit", group: "Compliance & Trust" },
    { label: "Personal AI Counselling", emoji: "🧑‍💼🤖", link: "/aicounselling", group: "Compliance & Trust" },
    { label: "Owner Productivity Suite", emoji: "🧠⚙️", link: "", group: "Compliance & Trust" }, 

    // Global Workforce & Talent  
    { label: "Workers (BlueHands)", emoji: "👷", link: "/bluehands-home", group: "Global Workforce & Talent" },
    { label: "Offboarded DB", emoji: "📤", link: "/offboarded-home", group: "Global Workforce & Talent" },
    { label: "Payment Dodger DB", emoji: "🚫💰", link: "/offboarded-home", group: "Global Workforce & Talent" },

    // Funding & Financial Access
    { label: "Compliances", emoji: "⚠️", link: "/msme-compliances", group: "Funding & Financial Access" },
    { label: "NPA Solutions", emoji: "⚠️", link: "/msme-npahome", group: "Funding & Financial Access" },
    { label: "Funding & Loans", emoji: "💰", link: "/fundlanes", group: "Funding & Financial Access" },

    // 📚 Knowledge & Learning
    { label: "MSME Success Kit", emoji: "🧰", link: "/startupkit", group: "Knowledge & Learning" },
    { label: "MSME Learning", emoji: "🗓️", link: "/msme-bookworld", group: "Knowledge & Learning" },
    { label: "MSME Bookshelf", emoji: "📖", link: "/bookshelf", group: "Knowledge & Learning" },
    { label: "MSME Shorts", emoji: "🗞️", link: "/litenshort", group: "Knowledge & Learning" },
    { label: "MSME Trainings & Workshops", emoji: "🎓", link: "/enroll/workshop", group: "Knowledge & Learning" },
    { label: "Podcast", emoji: "️🎙️", link: "/podcast-mylist", group: "Knowledge & Learning" },
    { label: "msmeTube", emoji: "️▶️", link: "/msmetube", group: "Knowledge & Learning" },
    { label: "startupTube", emoji: "⏩", link: "/startuptube", group: "Knowledge & Learning" },

    // Global Network & Collaboration 
    { label: "PehchaanSetu", emoji: "🔗", link: "/pehchaansetu", group: "Global Network & Collaboration" },

    // Global Dashboard 
    { label: "PehchaanSetu", emoji: "🔗", link: "/pehchaansetu", group: "Global Dashboard" },

    // 👥 Government & Institutional
    { label: "Digital Boutique", emoji: "🏬", link: "/digiboutique", group: "Government & Institutional" },
    { label: "Consultants", emoji: "🧑‍💼", link: "/think5whys-counsellors", group: "Government & Institutional" },

    // Integration Layer
    { label: "Ladder", emoji: "🪜", link: "/msme-think5whysmaturity", group: "Integration Layer" },
    { label: "Stakeholders", emoji: "👨‍💼", link: "/msme-think5whysroles", group: "Integration Layer" },
    { label: "SAKSHAM MSME Advisor", emoji: "🤝", link: "/msme-advisors", group: "Integration Layer" },
    { label: "Empowering PMMY Enterprises", emoji: "💪", link: "/growsure", group: "Integration Layer" },

    // TransNation X
    { label: "Ask Thinky", emoji: "👳", link: "/ami", group: "TransNation X" },
    { label: "Work with AI", emoji: "🤖", link: "/msme-vsai", group: "TransNation X" },
    { label: "AI for MSME", emoji: "👨‍💼", link: "/agenticsim", group: "TransNation X" },

    // MSME Owner's Productivity
    { label: "MSME Index Assessment", emoji: "🎯", link: "/msme-index", group: "MSME Owner's Productivity" },    
    { label: "MSME Process Maturity Assessment", emoji: "🧠", link: "/msme-selfassessment", group: "MSME Owner's Productivity" },    
    { label: "MSME Year Book", emoji: "📚", link: "/msmeyb-home", group: "MSME Owner's Productivity" },
    { label: "DeepThinking Lab", emoji: "🔍", link: "/fivewhys-analysis-home", group: "MSME Owner's Productivity" },
    { label: "Business Chronicles", emoji: "📖", link: "/msme-business-chronicles", group: "MSME Owner's Productivity" },
    { label: "Business Diary", emoji: "📓", link: "/mydiary-home", group: "MSME Owner's Productivity" },
    { label: "Business Journal", emoji: "🗒️", link: "/myjournal-home", group: "MSME Owner's Productivity" },
    { label: "Minutes of Meeting", emoji: "✍️", link: "/tasks/add", group: "MSME Owner's Productivity" },
    { label: "Goal Board", emoji: "🏁", link: "/msme-goalboard", group: "MSME Owner's Productivity" },
    { label: "Process & RACI Board", emoji: "🧩", link: "/msme-processraci", group: "MSME Owner's Productivity" },
    { label: "Kanban", emoji: "📊", link: "/sigmastudio-kanban", group: "MSME Owner's Productivity" },
    { label: "CommuniCapture", emoji: "📢", link: "/communicapture-home", group: "MSME Owner's Productivity" },
    { label: "TrackBuddy AI", emoji: "📍", link: "/trackbuddy", group: "MSME Owner's Productivity" },
    { label: "LLM Capture", emoji: "🧠🤖", link: "/msme-llmcapture", group: "MSME Owner's Productivity" },
    { label: "Auto Payment Reminder", emoji: "⏰💳", link: "/prs", group: "MSME Owner's Productivity" },
    { label: "MSME KRA", emoji: "📌", link: "/sigmastudio-kra", group: "MSME Owner's Productivity" },
    { label: "MSME KPI", emoji: "🎛️", link: "/sigmastudio-kpi", group: "MSME Owner's Productivity" },
    
    // 🚀 International Business Startup
    { label: "About HVAC Sector", emoji: "📚", link: "/hvac-about", group: "International Business Startup" },
    { label: "HVAC Glossary", emoji: "🔤", link: "/hvac-glossary", group: "International Business Startup" },
    { label: "HVAC Roles", emoji: "🦺", link: "/hvac-roles", group: "International Business Startup" },
    { label: "HVAC Services", emoji: "🛠️", link: "/hvac-masterlist", group: "International Business Startup" },
    { label: "HVAC Eqipments", emoji: "🔧", link: "/hvac-masterlist", group: "International Business Startup" },
    { label: "How To Open", emoji: "🗂️", link: "/hvac-howtoopen", group: "International Business Startup" },
    { label: "Startup Checklist", emoji: "📋", link: "/hvac-startup-checklist", group: "International Business Startup" },
    { label: "Startup Kit", emoji: "🧰", link: "/startupkit", group: "International Business Startup" },
    { label: "Startup ERP", emoji: "📊", link: "/ledger", group: "International Business Startup" },
    { label: "Startup Consultants", emoji: "🧑‍💼", link: "/think5whys-counsellors", group: "International Business Startup" },
    { label: "Startup Boutique", emoji: "🏬", link: "/digiboutique", group: "Talent Solutions" },
    { label: "Funding", emoji: "💰", link: "/fundlanes", group: "International Business Startup" },
    { label: "PMMY", emoji: "💪", link: "/growsure", group: "International Business Startup" },    

    // TransNations Research Desk
    { label: "Overview", emoji: "🧭", link: "", group: "TransNations Research Desk" },
    { label: "Research Library", emoji: "📚", link: "", group: "TransNations Research Desk" },
    { label: "Insights", emoji: "💡", link: "", group: "TransNations Research Desk" },
    { label: "Ask Research", emoji: "📝", link: "", group: "TransNations Research Desk" },
    { label: "Timeline Research", emoji: "🕰️", link: "", group: "TransNations Research Desk" },
    { label: "Compliance News", emoji: "📰", link: "/msme-compliance-news", group: "TransNations Research Desk" },
    { label: "Compliance Latest Rule", emoji: "📜", link: "/msme-compliance-rules", group: "TransNations Research Desk" },
    { label: "Team", emoji: "👩‍🔬", link: "", group: "TransNations Research Desk" },
    
    // SigmaStudio
    { label: "My Variations (Bell Curve)", emoji: "📋", link: "/sigmastudio-variations", group: "SigmaStudio" },
    { label: "Calculators", emoji: "🧮", link: "/sigmastudio-calculators", group: "SigmaStudio" },
    { label: "SIPOC", emoji: "🗺️", link: "/sigmastudio-sipoc", group: "SigmaStudio" },
    { label: "Process Flow", emoji: "🔀", link: "/sigmastudio-processcharts", group: "SigmaStudio" },
    { label: "Pareto Analysis", emoji: "📊", link: "/sigmastudio-pareto", group: "SigmaStudio" },
    { label: "5 Whys", emoji: "❓", link: "/fivewhys-analysis-home", group: "SigmaStudio" },
    { label: "5S", emoji: "🧹", link: "/fives-home", group: "SigmaStudio" },
    { label: "Poka-Yoke", emoji: "🛡️", link: "/sigmastudio-pokayoke", group: "SigmaStudio" },
    { label: "Kanban", emoji: "🪜", link: "/sigmastudio-kanban", group: "SigmaStudio" },
    { label: "Kaizen", emoji: "🔁", link: "/mykaizen-home", group: "SigmaStudio" },
    { label: "FMEA", emoji: "🔁", link: "/sigmastudio-fmea", group: "SigmaStudio" },
    { label: "7 Mudas", emoji: "🔁", link: "/sigmastudio-7mudas", group: "SigmaStudio" },
    { label: "Control Charts", emoji: "📈", link: "/sigmastudio-controlcharts", group: "SigmaStudio" },
    { label: "Fishbone (Ishikawa)", emoji: "🐟", link: "/fishbone-home", group: "SigmaStudio" },
    { label: "DOE", emoji: "🧪", link: "/doe", group: "SigmaStudio" },
    { label: "Gauge R&R", emoji: "📏", link: "/sigmastudio-rnr", group: "SigmaStudio" },
    { label: "Matrix Charts", emoji: "🗂️", link: "/sigmastudio-matrix", group: "SigmaStudio" },
    { label: "RACI Matrix", emoji: "👥", link: "/sigmastudio-raci", group: "SigmaStudio" },
    { label: "KRAs", emoji: "🎯", link: "/sigmastudio-kra", group: "SigmaStudio" },
    { label: "KPIs", emoji: "🏁", link: "/sigmastudio-kpi", group: "SigmaStudio" },
    { label: "Bias-Varinace Analysis", emoji: "📚", link: "/bv-usecases", group: "SigmaStudio" },
    { label: "My Bias-Variance History", emoji: "📊", link: "/bv-myhistory", group: "SigmaStudio" },
    { label: "About Bias-Varinace", emoji: "⚖️", link: "/bv-about", group: "SigmaStudio" },

    // Processifyd
    { label: "Dashboard", emoji: "📊", link: "/processifyd-dashboard", group: "Processifyd" },
    { label: "Clients", emoji: "🏢", link: "/processifyd-clients", group: "Processifyd" },
    { label: "Processes", emoji: "⚙️", link: "/processifyd-processes", group: "Processifyd" },
    { label: "States", emoji: "🔘", link: "/processifyd-states", group: "Processifyd" },
    { label: "State Transitions", emoji: "🔄", link: "/processifyd-statetransitions", group: "Processifyd" },
    { label: "Variables", emoji: "🔣", link: "/processifyd-variables", group: "Processifyd" },  
    { label: "Groups", emoji: "👥", link: "/processifyd-groups", group: "Processifyd" },
    { label: "RACI Persons", emoji: "👥", link: "/processifyd-racipersons", group: "Processifyd" },
    { label: "RACI", emoji: "🧩", link: "/processifyd-raci", group: "Processifyd" },
    { label: "Users", emoji: "👤", link: "/processifyd-users", group: "Processifyd" },
    { label: "Mappings", emoji: "🗺️", link: "/processifyd-mappings", group: "Processifyd" },
    { label: "One-View", emoji: "🧾", link: "/processifyd-oneview", group: "Processifyd" },
    { label: "Approvals", emoji: "✅", link: "", group: "Processifyd" },
    { label: "Help", emoji: "❓", link: "/processifyd-helptexts", group: "Processifyd" },
    { label: "Scripts", emoji: "📜", link: "/processifyd-scripts", group: "Processifyd" },
    { label: "Communications", emoji: "💬", link: "", group: "Processifyd" },
    { label: "References", emoji: "📎", link: "", group: "Processifyd" },
    { label: "Errors", emoji: "⚠️", link: "", group: "Processifyd" },
    { label: "Logs", emoji: "📚", link: "", group: "Processifyd" },
    { label: "IIOT & Telemetry", emoji: "📡", link: "", group: "Processifyd" },
    { label: "Training & Workshops", emoji: "🎓", link: "/enroll/workshop", group: "Processifyd" },
    { label: "BPM Immersive Books", emoji: "🗓️", link: "" },    
    { label: "Immersive Booksshelf", emoji: "📖", link: "/bookshelf" },
    { label: "BPM Skill Certification", emoji: "📜", link: "" },      

    // International Business Games
    { label: "MSME Tambola", emoji: "🎟️", link: "/msme-games-tambola", group: "International Business Games" },
    { label: "MSME Bingo", emoji: "🔢", link: "/msme-games-bingo", group: "International Business Games" },    
    { label: "Mind of a CEO Series", emoji: "🧠", link: "/msme-games-strategic", group: "International Business Games" },
    { label: "Operational Intelligence", emoji: "⚙️", link: "/msme-games-operational", group: "International Business Games" },
    { label: "Relaxation + Clarity", emoji: "🎯", link: "/msme-games-edutainment", group: "International Business Games" },
    { label: "Other Games", emoji: "🕹️", link: "/msme-games-other", group: "International Business Games" },
    
    // 💰 Student's Digital Income & Awards
    { label: "My Income Credit", emoji: "🌱", link: "/myincomecredits", group: "Student's Digital Income" },
    { label: "My Income", emoji: "💰", link: "/myincome", group: "Student's Digital Income" },
    { label: "Income Estimation", emoji: "🔗", link: "/orderflow-earning-estimator", group: "Student's Digital Income" },
    { label: "Kharcho Jeeto", emoji: "🗓️", link: "/kharchojeeto", group: "Student's Digital Income" },
    { label: "Photo Can Win", emoji: "🏁", link: "/photocanwin", group: "Student's Digital Income" },
    { label: "Become Reseller", emoji: "♻️", link: "/msme-enroll", group: "Student's Digital Income" },
    { label: "Rewarding Ads", emoji: "🎁📢", link: "/visigift-home", group: "Student's Digital Income" },
    { label: "Watch Rewarding Videos", emoji: "🎥", link: "/orderflow-spotbuy", group: "Student's Digital Income" },
    { label: "Create Digital Boutique", emoji: "🛍️", link: "/digiboutique", group: "Student's Digital Income" },

    // // Market & Engagement
    // { label: "MSME Marketplace", emoji: "🏪", link: "/orderflow-home", group: "Market & Engagement" },
    // { label: "Marketing Campaigns", emoji: "📣", link: "/treach", group: "Market & Engagement" },
    // { label: "CSAT", emoji: "💬", link: "/csat", group: "Market & Engagement" },
    // { label: "BoloGrahak", emoji: "🙋‍♀️", link: "/bolograhak", group: "Market & Engagement" },
    // { label: "Forum", emoji: "🗣️", link: "/povify-home", group: "Market & Engagement" },
    // { label: "TwiWrold", emoji: "🌐", link: "/twiworld", group: "Market & Engagement" },
    // { label: "MSME MetaVerse", emoji: "🕶️", link: "/msme-metaverse", group: "Market & Engagement" },
  ];

  // const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);
  const filteredButtons = menuButtons.filter((btn) => btn.group === activeTab );

  const selectedGroup = groupNames.find(g => g.label === activeTab);
  const [isGroupSelectorOpen, setIsGroupSelectorOpen] = useState(true);

  const handleSelectGroup = (label) => {
    setActiveTab(label);
    setIsGroupSelectorOpen(false);           // auto-minimize after selection
  };

  const toggleGroupSelector = () => {
    setIsGroupSelectorOpen(prev => !prev);
  };

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-200">🌍 TransNation</div>
          <div className="text-[11px] text-gray-200">Think5Whys International Business Platform: Enabling global expansion, cross-border trade and Transformation</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-8 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                <div className="flex gap-3">
                  <button
                    onClick={handleLogout}
                    className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                  >
                    ⏻
                  </button>
                </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">🔐</Link>
            </div>
          )}
        </div>
      )}

      {/* ─── Group Selector Area ─── */}
      <div className="mt-1 mb-1 px-3 py-2 border-b-2 border-gray-500 bg-gray-900/40">
        {isGroupSelectorOpen ? (
          <div className="grid grid-cols-3 lg:grid-cols-6 gap-2 place-items-center">
            {groupNames.map((group) => (
              <button
                key={group.label}
                onClick={() => handleSelectGroup(group.label)}
                className={`flex flex-col items-center justify-center w-full px-2 py-2 rounded-md text-xs font-medium transition ${
                  activeTab === group.label
                    ? "bg-teal-700 text-yellow-200 ring-2 ring-teal-400/50"
                    : "bg-gray-800 text-gray-200 hover:bg-gray-700"
                }`}
                aria-pressed={activeTab === group.label}
              >
                <span className="text-xl sm:text-2xl">{group.emoji}</span>
                <span className="mt-1 text-center">{group.label}</span>
              </button>
            ))}
          </div>
        ) : (
          selectedGroup && (
            <div className="flex items-center justify-between px-2 py-1.5 bg-gray-800/70 rounded-md">
              <div className="flex items-center gap-3">
                <span className="text-2xl">{selectedGroup.emoji}</span>
                <span className="text-xs lg:text-sm font-medium text-teal-200">{selectedGroup.label}</span>
              </div>

              <button
                onClick={toggleGroupSelector}
                className="w-24 lg:w-32 px-3 py-1.5 text-xs lg:text-sm bg-gray-700 hover:bg-gray-600 rounded text-gray-300 transition"
                title="Change category"
              >
                {isGroupSelectorOpen ? "▲ Hide" : "▼ Change"}
              </button>
            </div>
          )
        )}
      </div>

      {/* ─── Main Content ─── */}
      <main className="flex-grow mx-auto px-3 py-4 w-full">
        {activeTab === null ? (
          <div className="text-center text-gray-400 py-10">
            Select a category to begin
          </div>
        ) : activeTab === "About TransNation" ? (
          <TransNationsAbout />
        ) : (
          <div className="grid grid-cols-3 lg:grid-cols-6 gap-1 place-items-center">
            {filteredButtons.length === 0 ? (
              <div className="col-span-full text-center text-gray-400 py-1">
                No items in this category.
              </div>
            ) : (
              filteredButtons.map((btn, idx) => (
                <button
                  key={`${btn.label}-${idx}`}
                  onClick={() => navigate(btn.link)}
                  className="flex flex-col items-center justify-center w-full p-1 rounded-lg bg-cyan-900/60 hover:bg-teal-800/70 text-gray-100 hover:text-yellow-100 transition shadow-sm"
                  title={btn.label}
                >
                  <span className="text-sm lg:text-lg mb-1">{btn.emoji}</span>
                  <span className="text-xs lg:text-sm text-center leading-tight">{btn.label}</span>
                </button>
              ))
            )}
          </div>
        )}
      </main>

      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TransNationsHome;
